webpackJsonp([3],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _adLoader = __webpack_require__(23);
	
	var _adLoader2 = _interopRequireDefault(_adLoader);
	
	var _buildNestedRaces = __webpack_require__(25);
	
	var _buildNestedRaces2 = _interopRequireDefault(_buildNestedRaces);
	
	var _nestRaces = __webpack_require__(12);
	
	var _nestRaces2 = _interopRequireDefault(_nestRaces);
	
	var _SelectCache = __webpack_require__(9);
	
	var _SelectCache2 = _interopRequireDefault(_SelectCache);
	
	var _tocktimer = __webpack_require__(11);
	
	var _tocktimer2 = _interopRequireDefault(_tocktimer);
	
	var _selectors = __webpack_require__(3);
	
	var _utils = __webpack_require__(6);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _race = __webpack_require__(8);
	
	var _race2 = _interopRequireDefault(_race);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import scrollWatcher from './utils/scrollWatcher'
	/* global fetch */
	
	var config = window.EMBED_CONFIG;
	var countdownDuration = 30 * 1000; // 30 seconds
	var cache = new _SelectCache2.default();
	
	var el = (0, _selectors.select)('#race-results');
	var timerEl = (0, _selectors.select)('#timer');
	var timerUpdatingEl = (0, _selectors.select)('#timer-updating');
	var countdownEl = (0, _selectors.select)('#countdown');
	
	var timer = new _tocktimer2.default({
	  countdown: true,
	  interval: 1000,
	  callback: onTick,
	  complete: onComplete
	});
	
	function toggleTimerUpdate() {
	  timerEl.classList.toggle('hidden');
	  timerUpdatingEl.classList.toggle('hidden');
	}
	
	function onTick() {
	  countdownEl.textContent = ':' + Utils.zeroPaddingFormatter(Math.ceil(timer.lap() / 1000));
	}
	
	function onComplete() {
	  toggleTimerUpdate();
	  update();
	}
	
	fetch(config.url + '?_=' + +new Date()).then(function (resp) {
	  return resp.json();
	}).then(_nestRaces2.default).then(_buildNestedRaces2.default).then(function (payload) {
	  el.innerHTML = payload;
	  (0, _adLoader2.default)();
	  // timer.start(countdownDuration)
	}).catch(function (err) {
	  return console.error(err);
	});
	
	function update() {
	  fetch(config.url + '?_=' + +new Date()).then(function (resp) {
	    return resp.json();
	  }).then(function (races) {
	    if ('results' in races) races = races.results;
	
	    races.forEach(function (race) {
	      var selector = cache.get('#' + race.tt_race_slug);
	      if (selector) {
	        race.votes = Utils.getRaceVoteTotal(race.candidates);
	        var tpl = (0, _race2.default)({ race: race, Utils: Utils, is_embed: config.is_embed });
	        var div = document.createElement('div');
	        div.innerHTML = tpl;
	        selector.innerHTML = (0, _selectors.select)('.race', div).innerHTML;
	      }
	    });
	
	    window.setTimeout(function () {
	      toggleTimerUpdate();
	      timer.start(countdownDuration);
	    }, 1500);
	  });
	}
	
	// let originalTop = 0
	// let fixed = false
	//
	// const controls = select('#timer-row')
	// const controlsPlaceholder = select('#timer-row-placeholder')
	//
	// scrollWatcher.on('scroll', (data) => {
	//   const controlsTop = controls.getBoundingClientRect().top
	//
	//   if (!originalTop) originalTop = controlsTop
	//
	//   if (!fixed) {
	//     if (controlsTop <= 0) {
	//       controls.classList.add('fixed')
	//       controlsPlaceholder.classList.remove('hidden')
	//       fixed = true
	//     }
	//   }
	//
	//   if (fixed && originalTop > data.offset) {
	//     controls.classList.remove('fixed')
	//     controlsPlaceholder.classList.add('hidden')
	//     fixed = false
	//   }
	// })

/***/ },

/***/ 23:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = adLoader;
	/* global googletag */
	
	function adLoader() {
	  var gads = document.createElement('script');
	  gads.async = true;
	  gads.type = 'text/javascript';
	  var useSSL = document.location.protocol === 'https:';
	  gads.src = (useSSL ? 'https:' : 'http:') + '//www.googletagservices.com/tag/js/gpt.js';
	  var node = document.getElementsByTagName('script')[0];
	  node.parentNode.insertBefore(gads, node);
	
	  googletag.cmd.push(function () {
	    googletag.pubads().setTargeting('tribpedia', 'public-schools');
	
	    var bannerMapping = googletag.sizeMapping().addSize([768, 1], [728, 90]).addSize([0, 0], [300, 250]).build();
	
	    googletag.defineSlot('/5805113/TexasTribune_Data_DataPage_ATF_Header_Leaderboard_728x90', [728, 90], 'ad-banner-leader').defineSizeMapping(bannerMapping).addService(googletag.pubads());
	
	    googletag.defineSlot('/5805113/TexasTribune_Data_DataPage_BTF_Footer_Leaderboard_728x90', [728, 90], 'ad-banner-footer').defineSizeMapping(bannerMapping).addService(googletag.pubads());
	
	    googletag.pubads().enableSingleRequest();
	    googletag.enableServices();
	  });
	
	  googletag.cmd.push(function () {
	    googletag.display('ad-banner-leader');
	    googletag.display('ad-banner-footer');
	  });
	}

/***/ },

/***/ 25:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildNestedRaces;
	
	var _utils = __webpack_require__(6);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _order = __webpack_require__(5);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _office = __webpack_require__(14);
	
	var _office2 = _interopRequireDefault(_office);
	
	var _race = __webpack_require__(8);
	
	var _race2 = _interopRequireDefault(_race);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var config = window.EMBED_CONFIG;
	
	function buildNestedRaces(races) {
	  return new Promise(function (resolve, reject) {
	    var payload = races.map(function (obj, idx) {
	      var races = obj.values.reduce(function (prev, race) {
	        race.votes = Utils.getRaceVoteTotal(race.candidates);
	        return prev + (0, _race2.default)({ race: race, Utils: Utils, is_embed: config.is_embed });
	      }, '');
	
	      var title = _order2.default[obj.key];
	      var officePayload = (0, _office2.default)({ office_id: obj.key, title: title, races: races });
	      if (idx === 2) officePayload += '<aside class="ad-slot"><div id="ad-banner-leader"></div></aside>';
	
	      return officePayload;
	    }).join('');
	
	    resolve(payload);
	  });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }

});


/** WEBPACK FOOTER **
 ** scoreboard.js
 **/